import {api} from '@/plugins'
import {ref} from 'vue'
import {getInstance} from '../services/auth0plugin'
import {MANAGER} from '@/utils/constants'

export interface IUserInfo {
  id: number
  name: string
  email: string | null
  roles: []
}

let fetchDataPromise = null as any
const userId = ref(null)
const userName = ref(null)
const userEmail = ref(null)
const userRoles = ref([])
const isUserManager = ref(false)

export function useAccountSetting(lazy = false) {
  // Get account information
  !lazy && getAccount()

  return {
    userId,
    userName,
    userEmail,
    userRoles,
    isUserManager
  }
}

export async function getAccount(refresh = false): Promise<IUserInfo> {
  const authService = getInstance()
  if ((!fetchDataPromise || refresh) && authService.isAuthenticated) {
    fetchDataPromise = await api.get('/api/users/self').then(({data: user}) => {
      userId.value = user.id
      userName.value = user.name
      userEmail.value = user.email
      userRoles.value = user.roles
      isUserManager.value = user.roles.includes(MANAGER)
    })
  }
  return fetchDataPromise
}
